import React from 'react'

interface Props {
  width?: number
  height?: number
  color?: string
}
export const IconBack = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.8054 16.4727C11.545 16.7331 11.1229 16.7331 10.8626 16.4727L6.86258 12.4727C6.73756 12.3477 6.66732 12.1781 6.66732 12.0013C6.66732 11.8245 6.73756 11.6549 6.86258 11.5299L10.8626 7.5299C11.1229 7.26955 11.545 7.26955 11.8054 7.5299C12.0657 7.79025 12.0657 8.21236 11.8054 8.47271L8.94346 11.3346L16.6673 11.3346C17.0355 11.3346 17.334 11.6331 17.334 12.0013C17.334 12.3695 17.0355 12.668 16.6673 12.668L8.94346 12.668L11.8054 15.5299C12.0657 15.7902 12.0657 16.2124 11.8054 16.4727Z"
      fill="#32302D"
    />
  </svg>
)

export const IconCheckoutCreditCard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={173} height={20} viewBox="0 0 173 20" fill="none">
    <g clipPath="url(#clip0_295_13045)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-0.000244141 1.875C-0.000244141 0.839466 0.839222 0 1.87476 0H28.1248C29.1603 0 29.9998 0.839466 29.9998 1.875V18.125C29.9998 19.1605 29.1603 20 28.1248 20H1.87476C0.839222 20 -0.000244141 19.1605 -0.000244141 18.125V1.875Z"
        fill="#F4F6F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-0.000244141 1.875C-0.000244141 0.839466 0.839222 0 1.87476 0H28.1248C29.1603 0 29.9998 0.839466 29.9998 1.875V5H-0.000244141V1.875Z"
        fill="#4095DB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-0.000244141 15H29.9998V18.125C29.9998 19.1605 29.1603 20 28.1248 20H1.87476C0.839222 20 -0.000244141 19.1605 -0.000244141 18.125V15Z"
        fill="#F4B662"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1757 6.93887C18.8792 6.80925 18.4128 6.66781 17.8319 6.66781C16.3491 6.66781 15.3054 7.54433 15.2967 8.79932C15.2873 9.72755 16.0415 10.2454 16.6101 10.5539C17.1945 10.8702 17.3909 11.0726 17.3886 11.3554C17.3845 11.7879 16.9221 11.9861 16.4909 11.9861C15.8904 11.9861 15.5714 11.8885 15.0782 11.6474L14.8853 11.5446L14.6756 12.9903C15.0253 13.1701 15.6736 13.3263 16.3464 13.3345C17.9223 13.3345 18.9462 12.4686 18.9582 11.1285C18.9636 10.3923 18.564 9.83428 17.6985 9.3736C17.1744 9.0742 16.8527 8.87582 16.8564 8.5727C16.8567 8.30421 17.1281 8.01693 17.7155 8.01693C18.2061 8.00816 18.5612 8.13377 18.8379 8.26501L18.9726 8.33893L19.1757 6.93887ZM12.2374 13.2393L13.1757 6.7809H14.6754L13.7372 13.2393H12.2374ZM21.7737 9.14409C21.7737 9.14409 21.3005 10.578 21.1762 10.9492H22.4213C22.362 10.6264 22.0742 9.08486 22.0742 9.08486L21.973 8.52785C21.933 8.65576 21.8772 8.82531 21.8347 8.95426L21.8346 8.95448C21.7968 9.06945 21.7695 9.15209 21.7737 9.14409ZM23.0252 6.78714H21.8661C21.5066 6.78714 21.2376 6.90141 21.0801 7.3225L18.8528 13.2412H20.4281C20.4281 13.2412 20.6851 12.445 20.7434 12.2703C20.8241 12.2703 21.205 12.271 21.6087 12.2718L21.6088 12.2718C22.0641 12.2727 22.5485 12.2736 22.6643 12.2736C22.7092 12.499 22.8469 13.2412 22.8469 13.2412H24.2389L23.0252 6.78714ZM10.9825 6.7861L9.51455 11.1892L9.35732 10.2941C9.35638 10.2906 9.35542 10.287 9.35447 10.2834L8.83077 7.32644C8.7401 6.91717 8.47659 6.79585 8.15089 6.78154H5.73239L5.7124 6.91535C6.30127 7.08275 6.82779 7.3242 7.28916 7.62452L8.62272 13.2334L10.21 13.2323L12.5718 6.7861H10.9825Z"
        fill="#0071CE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1.5C0 0.671573 0.671573 0 1.5 0H30.5C31.3284 0 32 0.671573 32 1.5V19.5C32 20.3284 31.3284 21 30.5 21H1.5C0.671573 21 0 20.3284 0 19.5V1.5Z"
        fill="#E5E5E5"
        fillOpacity="0.01"
      />
    </g>
    <g clipPath="url(#clip1_295_13045)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.4766 1.875C35.4766 0.839466 36.316 0 37.3516 0H64.0778C65.1133 0 65.9528 0.839466 65.9528 1.875V18.125C65.9528 19.1605 65.1133 20 64.0778 20H37.3516C36.316 20 35.4766 19.1605 35.4766 18.125V1.875Z"
        fill="#F4F6F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.3836 15.2369C50.2765 15.2369 52.6217 12.8918 52.6217 9.99884C52.6217 7.10592 50.2765 4.76074 47.3836 4.76074C44.4907 4.76074 42.1455 7.10592 42.1455 9.99884C42.1455 12.8918 44.4907 15.2369 47.3836 15.2369Z"
        fill="#D8232A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.7156 14.039C51.6214 14.7873 52.783 15.2369 54.0497 15.2369C56.9426 15.2369 59.2878 12.8918 59.2878 9.99884C59.2878 7.10592 56.9426 4.76074 54.0497 4.76074C52.783 4.76074 51.6214 5.21036 50.7156 5.95871C51.8784 6.91947 52.6195 8.37261 52.6195 9.99884C52.6195 11.6251 51.8784 13.0782 50.7156 14.039Z"
        fill="#ED9F2D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.7148 5.95728C49.5515 6.91803 48.8101 8.37147 48.8101 9.99807C48.8101 11.6247 49.5515 13.0781 50.7148 14.0389C51.8782 13.0781 52.6196 11.6247 52.6196 9.99807C52.6196 8.37147 51.8782 6.91803 50.7148 5.95728Z"
        fill="#D8232A"
      />
      <mask
        id="mask0_295_13045"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x={48}
        y={5}
        width={5}
        height={10}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.7148 5.95728C49.5515 6.91803 48.8101 8.37147 48.8101 9.99807C48.8101 11.6247 49.5515 13.0781 50.7148 14.0389C51.8782 13.0781 52.6196 11.6247 52.6196 9.99807C52.6196 8.37147 51.8782 6.91803 50.7148 5.95728Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_295_13045)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.8601 6.66602H53.5744V7.6184H47.8601V6.66602ZM47.8601 8.57031H53.5744V9.52269H47.8601V8.57031ZM53.5744 10.4762H47.8601V11.4286H53.5744V10.4762ZM47.8601 12.3805H53.5744V13.3329H47.8601V12.3805ZM53.5744 14.2856H47.8601V15.238H53.5744V14.2856Z"
          fill="#ED9F2D"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.4761 1.5C35.4761 0.671573 36.1476 0 36.9761 0H58.357C59.1855 0 59.857 0.671573 59.857 1.5V14.5C59.857 15.3284 59.1855 16 58.357 16H36.9761C36.1476 16 35.4761 15.3284 35.4761 14.5V1.5Z"
        fill="#E5E5E5"
        fillOpacity="0.01"
      />
    </g>
    <g clipPath="url(#clip2_295_13045)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.9531 1.875C70.9531 0.839466 71.7926 0 72.8281 0H99.5543C100.59 0 101.429 0.839466 101.429 1.875V18.125C101.429 19.1605 100.59 20 99.5543 20H72.8281C71.7926 20 70.9531 19.1605 70.9531 18.125V1.875Z"
        fill="url(#paint0_radial_295_13045)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.9524 1.5C70.9524 0.671573 71.624 0 72.4524 0H93.8333C94.6618 0 95.3333 0.671573 95.3333 1.5V14.5C95.3333 15.3284 94.6618 16 93.8333 16H72.4524C71.624 16 70.9524 15.3284 70.9524 14.5V1.5Z"
        fill="#E5E5E5"
        fillOpacity="0.01"
      />
      <mask
        id="path-15-outside-1_295_13045"
        maskUnits="userSpaceOnUse"
        x="74.2566"
        y="5.62012"
        width={25}
        height={9}
        fill="black"
      >
        <rect fill="white" x="74.2566" y="5.62012" width={25} height={9} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M77.9965 10.5418L78.6316 8.79443H78.6452L79.2598 10.5418H77.9965ZM78.1004 7.62012L76.2566 12.382H77.3356L77.718 11.3216H79.5413L79.91 12.382H81.0232L79.1998 7.62012H78.1004ZM81.447 7.62012V12.382H82.4509V9.04069H82.4645L83.6596 12.382H84.4859L85.6809 9.00734H85.6946V12.382H86.6984V7.62012H85.1893L84.1103 10.8948H84.0966L82.9562 7.62012H81.447ZM87.6417 7.62012V12.382H91.3429V11.5017H88.7138V10.3345H91.0766V9.52088H88.7138V8.50047H91.2883V7.62012H87.6417ZM93.2597 9.88769L91.5593 12.382H92.7612L93.847 10.7347L94.9123 12.382H96.1893L94.4889 9.89436L96.0527 7.62012H94.8782L93.888 9.14073L92.9319 7.62012H91.6891L93.2597 9.88769Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.9965 10.5418L78.6316 8.79443H78.6452L79.2598 10.5418H77.9965ZM78.1004 7.62012L76.2566 12.382H77.3356L77.718 11.3216H79.5413L79.91 12.382H81.0232L79.1998 7.62012H78.1004ZM81.447 7.62012V12.382H82.4509V9.04069H82.4645L83.6596 12.382H84.4859L85.6809 9.00734H85.6946V12.382H86.6984V7.62012H85.1893L84.1103 10.8948H84.0966L82.9562 7.62012H81.447ZM87.6417 7.62012V12.382H91.3429V11.5017H88.7138V10.3345H91.0766V9.52088H88.7138V8.50047H91.2883V7.62012H87.6417ZM93.2597 9.88769L91.5593 12.382H92.7612L93.847 10.7347L94.9123 12.382H96.1893L94.4889 9.89436L96.0527 7.62012H94.8782L93.888 9.14073L92.9319 7.62012H91.6891L93.2597 9.88769Z"
        fill="#1793C0"
        fillOpacity="0.01"
      />
      <path
        d="M77.9965 10.5418L76.8217 10.1148L76.2122 11.7918H77.9965V10.5418ZM78.6316 8.79443V7.54443H77.7559L77.4568 8.36744L78.6316 8.79443ZM78.6452 8.79443L79.8244 8.37968L79.5307 7.54443H78.6452V8.79443ZM79.2598 10.5418V11.7918H81.0246L80.439 10.127L79.2598 10.5418ZM78.1004 7.62012V6.37012H77.244L76.9347 7.16877L78.1004 7.62012ZM76.2566 12.382L75.0909 11.9307L74.4322 13.632H76.2566V12.382ZM77.3356 12.382V13.632H78.2136L78.5114 12.8061L77.3356 12.382ZM77.718 11.3216V10.0716H76.84L76.5421 10.8975L77.718 11.3216ZM79.5413 11.3216L80.7219 10.911L80.43 10.0716H79.5413V11.3216ZM79.91 12.382L78.7294 12.7926L79.0213 13.632H79.91V12.382ZM81.0232 12.382V13.632H82.8403L82.1905 11.935L81.0232 12.382ZM79.1998 7.62012L80.3672 7.17314L80.0597 6.37012H79.1998V7.62012ZM81.447 7.62012V6.37012H80.197V7.62012H81.447ZM81.447 12.382H80.197V13.632H81.447V12.382ZM82.4509 12.382V13.632H83.7009V12.382H82.4509ZM82.4509 9.04069V7.79069H81.2009V9.04069H82.4509ZM82.4645 9.04069L83.6415 8.61973L83.345 7.79069H82.4645V9.04069ZM83.6596 12.382L82.4826 12.803L82.7791 13.632H83.6596V12.382ZM84.4859 12.382V13.632H85.3693L85.6642 12.7993L84.4859 12.382ZM85.6809 9.00734V7.75734H84.7975L84.5026 8.59007L85.6809 9.00734ZM85.6946 9.00734H86.9446V7.75734H85.6946V9.00734ZM85.6946 12.382H84.4446V13.632H85.6946V12.382ZM86.6984 12.382V13.632H87.9484V12.382H86.6984ZM86.6984 7.62012H87.9484V6.37012H86.6984V7.62012ZM85.1893 7.62012V6.37012H84.285L84.002 7.22894L85.1893 7.62012ZM84.1103 10.8948V12.1448H85.0145L85.2975 11.2859L84.1103 10.8948ZM84.0966 10.8948L82.9162 11.3059L83.2083 12.1448H84.0966V10.8948ZM82.9562 7.62012L84.1367 7.20901L83.8445 6.37012H82.9562V7.62012ZM87.6417 7.62012V6.37012H86.3917V7.62012H87.6417ZM87.6417 12.382H86.3917V13.632H87.6417V12.382ZM91.3429 12.382V13.632H92.5929V12.382H91.3429ZM91.3429 11.5017H92.5929V10.2517H91.3429V11.5017ZM88.7138 11.5017H87.4638V12.7517H88.7138V11.5017ZM88.7138 10.3345V9.08454H87.4638V10.3345H88.7138ZM91.0766 10.3345V11.5845H92.3266V10.3345H91.0766ZM91.0766 9.52088H92.3266V8.27088H91.0766V9.52088ZM88.7138 9.52088H87.4638V10.7709H88.7138V9.52088ZM88.7138 8.50047V7.25047H87.4638V8.50047H88.7138ZM91.2883 8.50047V9.75047H92.5383V8.50047H91.2883ZM91.2883 7.62012H92.5383V6.37012H91.2883V7.62012ZM93.2597 9.88769L94.2926 10.5918L94.7764 9.88205L94.2873 9.17594L93.2597 9.88769ZM91.5593 12.382L90.5265 11.6779L89.1944 13.632H91.5593V12.382ZM92.7612 12.382V13.632H93.4344L93.8049 13.0699L92.7612 12.382ZM93.847 10.7347L94.8966 10.0559L93.857 8.44822L92.8033 10.0468L93.847 10.7347ZM94.9123 12.382L93.8627 13.0608L94.2321 13.632H94.9123V12.382ZM96.1893 12.382V13.632H98.5578L97.2213 11.6766L96.1893 12.382ZM94.4889 9.89436L93.4589 9.18612L92.9734 9.89225L93.457 10.5997L94.4889 9.89436ZM96.0527 7.62012L97.0827 8.32836L98.4293 6.37012H96.0527V7.62012ZM94.8782 7.62012V6.37012H94.2005L93.8307 6.93801L94.8782 7.62012ZM93.888 9.14073L92.8298 9.80606L93.8695 11.4598L94.9355 9.82283L93.888 9.14073ZM92.9319 7.62012L93.9902 6.95479L93.6226 6.37012H92.9319V7.62012ZM91.6891 7.62012V6.37012H89.3027L90.6615 8.33187L91.6891 7.62012ZM79.1713 10.9688L79.8064 9.22142L77.4568 8.36744L76.8217 10.1148L79.1713 10.9688ZM78.6316 10.0444H78.6452V7.54443H78.6316V10.0444ZM77.4661 9.20919L78.0807 10.9566L80.439 10.127L79.8244 8.37968L77.4661 9.20919ZM79.2598 9.2918H77.9965V11.7918H79.2598V9.2918ZM76.9347 7.16877L75.0909 11.9307L77.4223 12.8334L79.2661 8.07146L76.9347 7.16877ZM76.2566 13.632H77.3356V11.132H76.2566V13.632ZM78.5114 12.8061L78.8938 11.7457L76.5421 10.8975L76.1597 11.958L78.5114 12.8061ZM77.718 12.5716H79.5413V10.0716H77.718V12.5716ZM78.3606 11.7322L78.7294 12.7926L81.0907 11.9715L80.7219 10.911L78.3606 11.7322ZM79.91 13.632H81.0232V11.132H79.91V13.632ZM82.1905 11.935L80.3672 7.17314L78.0325 8.06709L79.8558 12.829L82.1905 11.935ZM79.1998 6.37012H78.1004V8.87012H79.1998V6.37012ZM80.197 7.62012V12.382H82.697V7.62012H80.197ZM81.447 13.632H82.4509V11.132H81.447V13.632ZM83.7009 12.382V9.04069H81.2009V12.382H83.7009ZM82.4509 10.2907H82.4645V7.79069H82.4509V10.2907ZM81.2875 9.46164L82.4826 12.803L84.8366 11.9611L83.6415 8.61973L81.2875 9.46164ZM83.6596 13.632H84.4859V11.132H83.6596V13.632ZM85.6642 12.7993L86.8592 9.4246L84.5026 8.59007L83.3076 11.9648L85.6642 12.7993ZM85.6809 10.2573H85.6946V7.75734H85.6809V10.2573ZM84.4446 9.00734V12.382H86.9446V9.00734H84.4446ZM85.6946 13.632H86.6984V11.132H85.6946V13.632ZM87.9484 12.382V7.62012H85.4484V12.382H87.9484ZM86.6984 6.37012H85.1893V8.87012H86.6984V6.37012ZM84.002 7.22894L82.9231 10.5036L85.2975 11.2859L86.3765 8.01129L84.002 7.22894ZM84.1103 9.64476H84.0966V12.1448H84.1103V9.64476ZM85.2771 10.4837L84.1367 7.20901L81.7757 8.03122L82.9162 11.3059L85.2771 10.4837ZM82.9562 6.37012H81.447V8.87012H82.9562V6.37012ZM86.3917 7.62012V12.382H88.8917V7.62012H86.3917ZM87.6417 13.632H91.3429V11.132H87.6417V13.632ZM92.5929 12.382V11.5017H90.0929V12.382H92.5929ZM91.3429 10.2517H88.7138V12.7517H91.3429V10.2517ZM89.9638 11.5017V10.3345H87.4638V11.5017H89.9638ZM88.7138 11.5845H91.0766V9.08454H88.7138V11.5845ZM92.3266 10.3345V9.52088H89.8266V10.3345H92.3266ZM91.0766 8.27088H88.7138V10.7709H91.0766V8.27088ZM89.9638 9.52088V8.50047H87.4638V9.52088H89.9638ZM88.7138 9.75047H91.2883V7.25047H88.7138V9.75047ZM92.5383 8.50047V7.62012H90.0383V8.50047H92.5383ZM91.2883 6.37012H87.6417V8.87012H91.2883V6.37012ZM92.2269 9.1836L90.5265 11.6779L92.5922 13.0861L94.2926 10.5918L92.2269 9.1836ZM91.5593 13.632H92.7612V11.132H91.5593V13.632ZM93.8049 13.0699L94.8907 11.4226L92.8033 10.0468L91.7175 11.6941L93.8049 13.0699ZM92.7974 11.4135L93.8627 13.0608L95.962 11.7032L94.8966 10.0559L92.7974 11.4135ZM94.9123 13.632H96.1893V11.132H94.9123V13.632ZM97.2213 11.6766L95.5209 9.18898L93.457 10.5997L95.1574 13.0874L97.2213 11.6766ZM95.5189 10.6026L97.0827 8.32836L95.0227 6.91187L93.4589 9.18612L95.5189 10.6026ZM96.0527 6.37012H94.8782V8.87012H96.0527V6.37012ZM93.8307 6.93801L92.8405 8.45862L94.9355 9.82283L95.9257 8.30222L93.8307 6.93801ZM94.9462 8.47539L93.9902 6.95479L91.8737 8.28545L92.8298 9.80606L94.9462 8.47539ZM92.9319 6.37012H91.6891V8.87012H92.9319V6.37012ZM90.6615 8.33187L92.2321 10.5994L94.2873 9.17594L92.7166 6.90836L90.6615 8.33187Z"
        fill="white"
        mask="url(#path-15-outside-1_295_13045)"
      />
    </g>
    <g clipPath="url(#clip3_295_13045)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.426 1.875C106.426 0.839466 107.265 0 108.301 0H135.027C136.062 0 136.902 0.839466 136.902 1.875V18.125C136.902 19.1605 136.062 20 135.027 20H108.301C107.265 20 106.426 19.1605 106.426 18.125V1.875Z"
        fill="#F4F6F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.444 1.5C106.444 0.671573 107.115 0 107.944 0H129.325C130.153 0 130.825 0.671573 130.825 1.5V14.5C130.825 15.3284 130.153 16 129.325 16H107.944C107.115 16 106.444 15.3284 106.444 14.5V1.5Z"
        fill="#E5E5E5"
        fillOpacity="0.01"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.183 5.71289C126.086 5.71313 125.99 5.71607 125.895 5.72574C125.523 5.76349 125.173 5.92928 124.922 6.18507C124.736 6.37482 124.607 6.60982 124.552 6.8611C124.525 6.98515 124.522 7.10952 124.522 7.23521V8.06958V8.47403V8.59288C124.522 8.62471 124.513 8.62721 124.551 8.62721H125.146H125.738H126.334C126.529 8.62721 126.725 8.62044 126.919 8.63672C127.11 8.65279 127.304 8.70311 127.459 8.81173C127.676 8.9645 127.765 9.22802 127.69 9.47044C127.619 9.70314 127.405 9.85918 127.161 9.92396C127.134 9.93113 127.107 9.93729 127.079 9.94253C127.063 9.94559 127.041 9.94503 127.027 9.95127C127.02 9.95434 127.001 9.95816 127.015 9.96993C127.018 9.97287 127.032 9.97283 127.043 9.97275C127.047 9.97271 127.051 9.97271 127.053 9.97287C127.129 9.97968 127.206 9.99196 127.28 10.0107C127.508 10.0681 127.729 10.1915 127.834 10.394C127.959 10.6336 127.895 10.9304 127.694 11.1163C127.535 11.2627 127.313 11.3375 127.094 11.3622C126.984 11.3746 126.873 11.3721 126.763 11.3721H126.167H125.571H124.978H124.68H124.606C124.589 11.3721 124.541 11.3643 124.527 11.3721C124.519 11.3767 124.522 11.3833 124.522 11.3954V11.9046V12.8031V13.7111V14.2486C124.522 14.254 124.518 14.2775 124.522 14.2819C124.526 14.287 124.566 14.2825 124.576 14.2825H124.651H124.948H125.541H126.137H126.731C127.085 14.2825 127.422 14.1976 127.708 13.9992C128.097 13.7301 128.327 13.3024 128.329 12.8534C128.329 12.8361 128.329 12.8187 128.329 12.8013V12.7759C128.329 12.7374 128.329 12.699 128.329 12.6605V12.1873C128.329 11.9581 128.329 11.7291 128.329 11.5C128.329 11.2185 128.329 10.9371 128.329 10.6557C128.329 10.3452 128.329 10.0346 128.329 9.72405C128.329 9.40271 128.329 9.08133 128.329 8.76C128.329 8.4501 128.329 8.14025 128.329 7.83035C128.329 7.55401 128.329 7.27772 128.329 7.00138C128.329 6.77722 128.329 6.55306 128.329 6.32889V5.88109C128.329 5.82642 128.329 5.77175 128.329 5.71704H128.323C128.134 5.71732 127.944 5.71704 127.755 5.71704H127.161H126.565C126.447 5.71704 126.328 5.71317 126.208 5.71289H126.183ZM125.474 9.15229C125.47 9.16465 125.474 9.19199 125.474 9.20528V9.6814V9.90391C125.474 9.9225 125.468 9.98637 125.477 9.99581C125.485 10.0039 125.518 9.99581 125.528 9.99581H125.584H125.691H125.903C125.973 9.99581 126.043 9.99764 126.112 9.99581C126.199 9.99354 126.282 9.95636 126.344 9.86515C126.413 9.76198 126.438 9.61021 126.417 9.47095C126.407 9.40936 126.389 9.35161 126.361 9.30223C126.309 9.20761 126.23 9.15516 126.147 9.14547C126.108 9.14087 126.068 9.14299 126.029 9.14299H125.816H125.6H125.495C125.489 9.14299 125.485 9.14225 125.482 9.14225C125.478 9.14225 125.476 9.14393 125.474 9.15229ZM125.899 9.99874H125.473C125.473 10.0066 125.473 10.0145 125.473 10.0223V10.4484V10.7V10.7918C125.473 10.8049 125.47 10.8326 125.473 10.8447C125.479 10.8629 125.532 10.8526 125.549 10.8526H125.657H125.87H126.084C126.153 10.8526 126.22 10.8465 126.282 10.7938C126.357 10.7297 126.408 10.6178 126.421 10.4932C126.435 10.3508 126.402 10.2033 126.328 10.1066C126.267 10.0284 126.193 9.99961 126.113 9.99874C126.09 9.99846 126.066 9.99837 126.042 9.99837C125.994 9.99837 125.947 9.99874 125.899 9.99874Z"
        fill="url(#paint1_linear_295_13045)"
      />
      <mask
        id="mask1_295_13045"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x={124}
        y={5}
        width={5}
        height={10}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M126.183 5.71289C126.086 5.71313 125.99 5.71607 125.895 5.72574C125.523 5.76349 125.173 5.92928 124.922 6.18507C124.736 6.37482 124.607 6.60982 124.552 6.8611C124.525 6.98515 124.522 7.10952 124.522 7.23521V8.06958V8.47403V8.59288C124.522 8.62471 124.513 8.62721 124.551 8.62721H125.146H125.738H126.334C126.529 8.62721 126.725 8.62044 126.919 8.63672C127.11 8.65279 127.304 8.70311 127.459 8.81173C127.676 8.9645 127.765 9.22802 127.69 9.47044C127.619 9.70314 127.405 9.85918 127.161 9.92396C127.134 9.93113 127.107 9.93729 127.079 9.94253C127.063 9.94559 127.041 9.94503 127.027 9.95127C127.02 9.95434 127.001 9.95816 127.015 9.96993C127.018 9.97287 127.032 9.97283 127.043 9.97275C127.047 9.97271 127.051 9.97271 127.053 9.97287C127.129 9.97968 127.206 9.99196 127.28 10.0107C127.508 10.0681 127.729 10.1915 127.834 10.394C127.959 10.6336 127.895 10.9304 127.694 11.1163C127.535 11.2627 127.313 11.3375 127.094 11.3622C126.984 11.3746 126.873 11.3721 126.763 11.3721H126.167H125.571H124.978H124.68H124.606C124.589 11.3721 124.541 11.3643 124.527 11.3721C124.519 11.3767 124.522 11.3833 124.522 11.3954V11.9046V12.8031V13.7111V14.2486C124.522 14.254 124.518 14.2775 124.522 14.2819C124.526 14.287 124.566 14.2825 124.576 14.2825H124.651H124.948H125.541H126.137H126.731C127.085 14.2825 127.422 14.1976 127.708 13.9992C128.097 13.7301 128.327 13.3024 128.329 12.8534C128.329 12.8361 128.329 12.8187 128.329 12.8013V12.7759C128.329 12.7374 128.329 12.699 128.329 12.6605V12.1873C128.329 11.9581 128.329 11.7291 128.329 11.5C128.329 11.2185 128.329 10.9371 128.329 10.6557C128.329 10.3452 128.329 10.0346 128.329 9.72405C128.329 9.40271 128.329 9.08133 128.329 8.76C128.329 8.4501 128.329 8.14025 128.329 7.83035C128.329 7.55401 128.329 7.27772 128.329 7.00138C128.329 6.77722 128.329 6.55306 128.329 6.32889V5.88109C128.329 5.82642 128.329 5.77175 128.329 5.71704H128.323C128.134 5.71732 127.944 5.71704 127.755 5.71704H127.161H126.565C126.447 5.71704 126.328 5.71317 126.208 5.71289H126.183ZM125.474 9.15229C125.47 9.16465 125.474 9.19199 125.474 9.20528V9.6814V9.90391C125.474 9.9225 125.468 9.98637 125.477 9.99581C125.485 10.0039 125.518 9.99581 125.528 9.99581H125.584H125.691H125.903C125.973 9.99581 126.043 9.99764 126.112 9.99581C126.199 9.99354 126.282 9.95636 126.344 9.86515C126.413 9.76198 126.438 9.61021 126.417 9.47095C126.407 9.40936 126.389 9.35161 126.361 9.30223C126.309 9.20761 126.23 9.15516 126.147 9.14547C126.108 9.14087 126.068 9.14299 126.029 9.14299H125.816H125.6H125.495C125.489 9.14299 125.485 9.14225 125.482 9.14225C125.478 9.14225 125.476 9.14393 125.474 9.15229ZM125.899 9.99874H125.473C125.473 10.0066 125.473 10.0145 125.473 10.0223V10.4484V10.7V10.7918C125.473 10.8049 125.47 10.8326 125.473 10.8447C125.479 10.8629 125.532 10.8526 125.549 10.8526H125.657H125.87H126.084C126.153 10.8526 126.22 10.8465 126.282 10.7938C126.357 10.7297 126.408 10.6178 126.421 10.4932C126.435 10.3508 126.402 10.2033 126.328 10.1066C126.267 10.0284 126.193 9.99961 126.113 9.99874C126.09 9.99846 126.066 9.99837 126.042 9.99837C125.994 9.99837 125.947 9.99874 125.899 9.99874Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_295_13045)"></g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.293 5.73195C116.073 5.76488 115.863 5.84295 115.679 5.95801C115.255 6.2232 115.002 6.67221 115 7.14472C114.999 7.28364 115 7.42256 115 7.56152V8.44637V9.47513V10.3237V10.5798V10.6474C115 10.6736 115 10.6681 115.032 10.6823C115.068 10.698 115.104 10.7133 115.14 10.7281C115.429 10.8465 115.733 10.9366 116.047 10.972C116.273 10.9976 116.514 11.0046 116.728 10.9213C116.899 10.8545 117.035 10.7312 117.105 10.5714C117.15 10.4687 117.163 10.3602 117.163 10.2504V9.03252V8.75835V8.67089C117.163 8.66214 117.157 8.63486 117.163 8.62753C117.169 8.61838 117.222 8.62422 117.237 8.62422H117.353H117.58H118.491V8.64933V9.85159C118.491 9.99273 118.491 10.1339 118.491 10.275C118.49 10.4395 118.464 10.6045 118.391 10.7557C118.319 10.9063 118.203 11.0335 118.059 11.1303C117.711 11.3653 117.249 11.4265 116.828 11.4441C116.527 11.4568 116.224 11.4459 115.925 11.4181C115.615 11.3895 115.301 11.347 115 11.2719V11.3694V12.0379V13.0132V13.8943V14.1746V14.2532C115 14.2574 114.997 14.2781 115 14.2815C115.006 14.2878 115.063 14.2815 115.075 14.2815H115.151H115.307H115.616H116.235H116.854C117.117 14.2815 117.386 14.2982 117.643 14.2382C118.091 14.1334 118.473 13.8398 118.667 13.4512C118.773 13.2379 118.808 13.0112 118.808 12.7789V12.3962V11.7513V10.9157V9.96452V8.96127V7.98079V7.09768V6.37595V5.89062V5.71301H118.654H118.011H117.367H116.726C116.697 5.71301 116.669 5.71289 116.64 5.71289C116.524 5.71289 116.408 5.71462 116.293 5.73195Z"
        fill="url(#paint2_linear_295_13045)"
      />
      <mask
        id="mask2_295_13045"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x={114}
        y={5}
        width={5}
        height={10}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M116.293 5.73195C116.073 5.76488 115.863 5.84295 115.679 5.95801C115.255 6.2232 115.002 6.67221 115 7.14472C114.999 7.28364 115 7.42256 115 7.56152V8.44637V9.47513V10.3237V10.5798V10.6474C115 10.6736 115 10.6681 115.032 10.6823C115.068 10.698 115.104 10.7133 115.14 10.7281C115.429 10.8465 115.733 10.9366 116.047 10.972C116.273 10.9976 116.514 11.0046 116.728 10.9213C116.899 10.8545 117.035 10.7312 117.105 10.5714C117.15 10.4687 117.163 10.3602 117.163 10.2504V9.03252V8.75835V8.67089C117.163 8.66214 117.157 8.63486 117.163 8.62753C117.169 8.61838 117.222 8.62422 117.237 8.62422H117.353H117.58H118.491V8.64933V9.85159C118.491 9.99273 118.491 10.1339 118.491 10.275C118.49 10.4395 118.464 10.6045 118.391 10.7557C118.319 10.9063 118.203 11.0335 118.059 11.1303C117.711 11.3653 117.249 11.4265 116.828 11.4441C116.527 11.4568 116.224 11.4459 115.925 11.4181C115.615 11.3895 115.301 11.347 115 11.2719V11.3694V12.0379V13.0132V13.8943V14.1746V14.2532C115 14.2574 114.997 14.2781 115 14.2815C115.006 14.2878 115.063 14.2815 115.075 14.2815H115.151H115.307H115.616H116.235H116.854C117.117 14.2815 117.386 14.2982 117.643 14.2382C118.091 14.1334 118.473 13.8398 118.667 13.4512C118.773 13.2379 118.808 13.0112 118.808 12.7789V12.3962V11.7513V10.9157V9.96452V8.96127V7.98079V7.09768V6.37595V5.89062V5.71301H118.654H118.011H117.367H116.726C116.697 5.71301 116.669 5.71289 116.64 5.71289C116.524 5.71289 116.408 5.71462 116.293 5.73195Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_295_13045)"></g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.207 5.71644C121.04 5.72623 120.875 5.76108 120.72 5.81999C120.379 5.95003 120.095 6.19272 119.928 6.49723C119.818 6.69661 119.763 6.91823 119.762 7.14162C119.762 7.17777 119.762 7.21391 119.762 7.2501V7.88393V9.01074C119.772 9.00244 119.783 8.99426 119.794 8.98616C119.832 8.95755 119.872 8.93079 119.913 8.90573C120.168 8.74975 120.466 8.66239 120.764 8.61081C121.008 8.56882 121.255 8.55077 121.502 8.54638C121.745 8.54211 121.989 8.54976 122.231 8.57398C122.478 8.59864 122.723 8.63712 122.966 8.68524C122.995 8.69116 123.025 8.6972 123.055 8.70349C123.071 8.70687 123.132 8.71147 123.14 8.72275C123.146 8.73081 123.14 8.76296 123.14 8.77227V8.88848V9.32661C123.106 9.31053 123.071 9.29477 123.036 9.27954C122.772 9.1641 122.494 9.07835 122.205 9.0362C121.817 8.97951 121.378 8.98108 121.043 9.19581C120.72 9.40309 120.607 9.7709 120.642 10.1207C120.676 10.461 120.879 10.7528 121.222 10.8889C121.56 11.0233 121.953 11.0052 122.307 10.9404C122.598 10.8872 122.875 10.7898 123.14 10.6677V10.7109V11.2215C123.14 11.2311 123.146 11.2633 123.14 11.2715C123.132 11.2825 123.07 11.2871 123.055 11.2904C122.993 11.3034 122.931 11.3157 122.869 11.3272C122.624 11.3727 122.377 11.4088 122.129 11.4294C121.886 11.4495 121.64 11.4535 121.396 11.445C121.147 11.4364 120.898 11.4126 120.655 11.3627C120.334 11.2969 120.014 11.1838 119.762 10.9837V11.0778V11.7354V12.7166V13.6718V14.2382C119.762 14.2449 119.757 14.2729 119.762 14.2783C119.772 14.29 119.859 14.2804 119.879 14.2804H120.195H120.831H121.463C121.687 14.2804 121.914 14.2914 122.136 14.2767C122.54 14.25 122.922 14.0735 123.189 13.7913C123.444 13.521 123.569 13.1789 123.569 12.8224V12.5027V11.8914V11.0658V10.1024V9.0817V8.07199V7.1571V6.40612V5.89942V5.71354H123.453H122.471H121.493C121.447 5.71354 121.401 5.71289 121.354 5.71289C121.305 5.71289 121.256 5.71362 121.207 5.71644Z"
        fill="url(#paint3_linear_295_13045)"
      />
      <mask
        id="mask3_295_13045"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x={119}
        y={5}
        width={5}
        height={10}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M121.207 5.71644C121.04 5.72623 120.875 5.76108 120.72 5.81999C120.379 5.95003 120.095 6.19272 119.928 6.49723C119.818 6.69661 119.763 6.91823 119.762 7.14162C119.762 7.17777 119.762 7.21391 119.762 7.2501V7.88393V9.01074C119.772 9.00244 119.783 8.99426 119.794 8.98616C119.832 8.95755 119.872 8.93079 119.913 8.90573C120.168 8.74975 120.466 8.66239 120.764 8.61081C121.008 8.56882 121.255 8.55077 121.502 8.54638C121.745 8.54211 121.989 8.54976 122.231 8.57398C122.478 8.59864 122.723 8.63712 122.966 8.68524C122.995 8.69116 123.025 8.6972 123.055 8.70349C123.071 8.70687 123.132 8.71147 123.14 8.72275C123.146 8.73081 123.14 8.76296 123.14 8.77227V8.88848V9.32661C123.106 9.31053 123.071 9.29477 123.036 9.27954C122.772 9.1641 122.494 9.07835 122.205 9.0362C121.817 8.97951 121.378 8.98108 121.043 9.19581C120.72 9.40309 120.607 9.7709 120.642 10.1207C120.676 10.461 120.879 10.7528 121.222 10.8889C121.56 11.0233 121.953 11.0052 122.307 10.9404C122.598 10.8872 122.875 10.7898 123.14 10.6677V10.7109V11.2215C123.14 11.2311 123.146 11.2633 123.14 11.2715C123.132 11.2825 123.07 11.2871 123.055 11.2904C122.993 11.3034 122.931 11.3157 122.869 11.3272C122.624 11.3727 122.377 11.4088 122.129 11.4294C121.886 11.4495 121.64 11.4535 121.396 11.445C121.147 11.4364 120.898 11.4126 120.655 11.3627C120.334 11.2969 120.014 11.1838 119.762 10.9837V11.0778V11.7354V12.7166V13.6718V14.2382C119.762 14.2449 119.757 14.2729 119.762 14.2783C119.772 14.29 119.859 14.2804 119.879 14.2804H120.195H120.831H121.463C121.687 14.2804 121.914 14.2914 122.136 14.2767C122.54 14.25 122.922 14.0735 123.189 13.7913C123.444 13.521 123.569 13.1789 123.569 12.8224V12.5027V11.8914V11.0658V10.1024V9.0817V8.07199V7.1571V6.40612V5.89942V5.71354H123.453H122.471H121.493C121.447 5.71354 121.401 5.71289 121.354 5.71289C121.305 5.71289 121.256 5.71362 121.207 5.71644Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_295_13045)"></g>
    </g>
    <g clipPath="url(#clip4_295_13045)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.904 1.875C141.904 0.839466 142.744 0 143.779 0H170.505C171.541 0 172.38 0.839466 172.38 1.875V18.125C172.38 19.1605 171.541 20 170.505 20H143.779C142.744 20 141.904 19.1605 141.904 18.125V1.875Z"
        fill="url(#paint4_linear_295_13045)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.905 1.5C141.905 0.671573 142.576 0 143.405 0H164.785C165.614 0 166.285 0.671573 166.285 1.5V14.5C166.285 15.3284 165.614 16 164.785 16H143.405C142.576 16 141.905 15.3284 141.905 14.5V1.5Z"
        fill="#E5E5E5"
        fillOpacity="0.01"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M148.587 10.794C148.386 10.9763 148.126 11.0558 147.713 11.0558H147.542V8.87882H147.713C148.126 8.87882 148.376 8.9531 148.587 9.14514C148.807 9.34278 148.94 9.64929 148.94 9.96457C148.94 10.2806 148.807 10.5964 148.587 10.794ZM147.841 8.32056H146.904V11.6124H147.836C148.332 11.6124 148.689 11.4949 149.003 11.2324C149.377 10.9217 149.597 10.4533 149.597 9.96883C149.597 8.99729 148.876 8.32056 147.841 8.32056Z"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M149.889 11.6125H150.528V8.32056H149.889V11.6125Z"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M152.088 9.58371C151.705 9.44114 151.593 9.34715 151.593 9.16923C151.593 8.96192 151.793 8.80434 152.068 8.80434C152.26 8.80434 152.417 8.88345 152.583 9.07092L152.917 8.631C152.643 8.38948 152.314 8.26611 151.956 8.26611C151.377 8.26611 150.935 8.67055 150.935 9.20929C150.935 9.66282 151.141 9.89505 151.74 10.112C151.99 10.2008 152.117 10.2598 152.181 10.2995C152.309 10.3833 152.373 10.502 152.373 10.6402C152.373 10.9069 152.162 11.1045 151.877 11.1045C151.573 11.1045 151.327 10.9513 151.181 10.6654L150.768 11.0649C151.062 11.4992 151.415 11.6916 151.901 11.6916C152.564 11.6916 153.029 11.2479 153.029 10.6107C153.029 10.0876 152.814 9.85092 152.088 9.58371Z"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M153.232 9.96925C153.232 10.9368 153.988 11.6871 154.959 11.6871C155.234 11.6871 155.469 11.6328 155.759 11.4953V10.7395C155.504 10.9964 155.278 11.1 154.989 11.1C154.346 11.1 153.89 10.6311 153.89 9.96442C153.89 9.33246 154.361 8.83391 154.959 8.83391C155.264 8.83391 155.494 8.94315 155.759 9.20426V8.4488C155.479 8.30585 155.249 8.24658 154.974 8.24658C154.007 8.24658 153.232 9.01209 153.232 9.96925Z"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160.818 10.5317L159.945 8.32056H159.248L160.636 11.697H160.98L162.393 8.32056H161.701L160.818 10.5317Z"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M162.682 11.6125H164.492V11.0552H163.32V10.1666H164.449V9.60903H163.32V8.87837H164.492V8.32056H162.682V11.6125Z"
        fill="#212D34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M165.736 9.83674H165.55V8.83976H165.746C166.144 8.83976 166.36 9.00726 166.36 9.32763C166.36 9.65856 166.144 9.83674 165.736 9.83674ZM167.017 9.29248C167.017 8.67616 166.596 8.32056 165.86 8.32056H164.913V11.6125H165.551V10.2901H165.634L166.517 11.6125H167.302L166.272 10.2257C166.753 10.1273 167.017 9.7965 167.017 9.29248Z"
        fill="#212D34"
      />
      <g filter="url(#filter0_i_295_13045)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M159.448 9.97821C159.448 10.9454 158.668 11.7295 157.707 11.7295C156.746 11.7295 155.967 10.9454 155.967 9.97821C155.967 9.011 156.746 8.22705 157.707 8.22705C158.668 8.22705 159.448 9.011 159.448 9.97821Z"
          fill="url(#paint5_linear_295_13045)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_295_13045"
        x="155.967"
        y="8.22705"
        width="3.48071"
        height="3.50244"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.25" dy="1.25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix type="matrix" values="0 0 0 0 0.314068 0 0 0 0 0.00146228 0 0 0 0 0.00146228 0 0 0 0.5 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_295_13045" />
      </filter>
      <radialGradient
        id="paint0_radial_295_13045"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(81.1875 3.79092) rotate(90) scale(20 30.4762)"
      >
        <stop stopColor="#71C8F2" />
        <stop offset={1} stopColor="#0071BD" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_295_13045"
        x1="128.329"
        y1="5.34219"
        x2="124.649"
        y2="5.34219"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#43C311" />
        <stop offset={1} stopColor="#288C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_295_13045"
        x1="115.008"
        y1="14.3057"
        x2="118.856"
        y2="14.3057"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21469E" />
        <stop offset={1} stopColor="#1E81EB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_295_13045"
        x1="123.569"
        y1="5.71289"
        x2="119.76"
        y2="5.71289"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F42D3E" />
        <stop offset={1} stopColor="#9C0017" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_295_13045"
        x1="126.666"
        y1={10}
        x2="145.014"
        y2="37.959"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EDF1F3" />
        <stop offset={1} stopColor="#D3DADF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_295_13045"
        x1="159.839"
        y1="10.313"
        x2="157.774"
        y2="7.8704"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA700" />
        <stop offset={1} stopColor="#E75A10" />
      </linearGradient>
      <clipPath id="clip0_295_13045">
        <rect width="30.4762" height={20} fill="white" />
      </clipPath>
      <clipPath id="clip1_295_13045">
        <rect width="30.4762" height={20} fill="white" transform="translate(35.4761)" />
      </clipPath>
      <clipPath id="clip2_295_13045">
        <rect width="30.4762" height={20} fill="white" transform="translate(70.9524)" />
      </clipPath>
      <clipPath id="clip3_295_13045">
        <rect width="30.4762" height={20} fill="white" transform="translate(106.428)" />
      </clipPath>
      <clipPath id="clip4_295_13045">
        <rect width="30.4762" height={20} fill="white" transform="translate(141.905)" />
      </clipPath>
    </defs>
  </svg>
)

export const IcClose: React.FC<Props> = ({ width = 24, height = 24, color = '#292926' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.46967 7.46967C7.76256 7.17678 8.23744 7.17678 8.53033 7.46967L16.5303 15.4696C16.8232 15.7625 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7625 16.8232 15.4696 16.5303L7.46967 8.53033C7.17678 8.23744 7.17678 7.76256 7.46967 7.46967Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5304 7.46967C16.8232 7.76256 16.8232 8.23744 16.5304 8.53033L8.53033 16.5304C8.23744 16.8232 7.76256 16.8232 7.46967 16.5304C7.17678 16.2375 7.17678 15.7626 7.46967 15.4697L15.4697 7.46967C15.7626 7.17678 16.2375 7.17678 16.5304 7.46967Z"
        fill={color}
      />
    </svg>
  )
}

export const IcGuest = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        d="M7.5 9.5C9.15685 9.5 10.5 8.15685 10.5 6.5C10.5 4.84315 9.15685 3.5 7.5 3.5C5.84315 3.5 4.5 4.84315 4.5 6.5C4.5 8.15685 5.84315 9.5 7.5 9.5Z"
        stroke="#292926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 17.5V14.1667C1.5 13 2 12.5 3.33341 12.5H11.6667C13 12.5 13.5 13 13.5 14.1667V17.5"
        stroke="#292926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 3.5C13.6661 3.67055 14.2565 4.05796 14.6781 4.60114C15.0998 5.14433 15.3286 5.81238 15.3286 6.5C15.3286 7.18762 15.0998 7.85567 14.6781 8.39886C14.2565 8.94204 13.6661 9.32944 13 9.5"
        stroke="#292926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 12.5H16C17 12.5 17.5 13 17.5 14.1667V17.5"
        stroke="#292926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const IcBed = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path d="M5.5 8.5H8.5" stroke="#292926" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.5 8.5H14.5" stroke="#292926" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M17.5 14.5V17.5M17.5 14.5H2.50001M17.5 14.5V12C17.5 11.0795 16.9205 10.5 16 10.5H4.00001C3.07954 10.5 2.5 11.0795 2.5 12L2.50001 17.5"
        stroke="#292926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 8.49989V4.99989C2.5 3.99989 3 3.49989 4 3.49989H16C17 3.49989 17.5 3.99989 17.5 4.99989V8.49989"
        stroke="#292926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const IcBath = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        d="M17 12.5001L15.1333 17.5001H4.86668L3 12.5001"
        stroke="#292926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 5C12.5 4 13 3.5 14 3.5C15 3.5 15.5 4 15.5 5V10.5"
        stroke="#292926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="2.5" y="10.5" width={15} height={2} rx={1} stroke="#292926" />
      <rect x={14} y={17} width={1} height={2} rx="0.5" fill="#292926" />
      <rect x={5} y={17} width={1} height={2} rx="0.5" fill="#292926" />
      <path d="M12.5 5C11.6716 5 11 5.44772 11 6H14C14 5.44772 13.3284 5 12.5 5Z" fill="#292926" />
    </svg>
  )
}
export const IconUnChecked = ({ color }: { color?: string }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke={color ? color : '#CFCFCF'} />
    </svg>
  )
}

export const IconChecked = ({ color }: { color?: string }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="4" fill={color ? color : '#0F0F0E'} />
      <path d="M12 5L6.5 10.5L4 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const IconInfo = ({ color }: { color?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
        stroke={color ? color : '#6B6B6B'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9668 10.3H8.03346V10.3666H7.9668V10.3Z"
        stroke={color ? color : '#6B6B6B'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5.6333V8.29997"
        stroke={color ? color : '#6B6B6B'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const IcCalendar = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none">
      <path d="M4 8H20" stroke="#292926" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M19 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4Z"
        stroke="#292926"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16 2V4" stroke="#292926" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 2V4" stroke="#292926" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
export const IcChervonDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.72481 7.05806C3.96888 6.81398 4.36461 6.81398 4.60869 7.05806L10.0001 12.4495L15.3915 7.05806C15.6356 6.81398 16.0313 6.81398 16.2754 7.05806C16.5194 7.30214 16.5194 7.69786 16.2754 7.94194L10.442 13.7753C10.3248 13.8925 10.1658 13.9583 10.0001 13.9583C9.83432 13.9583 9.67535 13.8925 9.55814 13.7753L3.72481 7.94194C3.48073 7.69786 3.48073 7.30214 3.72481 7.05806Z"
        fill="#292926"
      />
    </svg>
  )
}
export const IcUsers = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none">
      <path
        d="M17 16.2276C19.3304 16.7767 21 18.2584 21 20"
        stroke="#292926"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 20C3 17.7909 5.68629 16 9 16C12.3137 16 15 17.7909 15 20"
        stroke="#292926"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5"
        stroke="#292926"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 13C11.2091 13 13 11.2091 13 9C13 6.79086 11.2091 5 9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13Z"
        stroke="#292926"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const IcMinus: React.FC<Props> = ({ width = 40, height = 40, color = '#E3E0DF' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5">
        <rect x="0.5" y="0.5" width={39} height={39} rx="19.5" fill="white" />
        <path d="M14 20H26" stroke="#32302D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="0.5" y="0.5" width={39} height={39} rx="19.5" stroke={color} />
      </g>
    </svg>
  )
}
export const IcPlus: React.FC<Props> = ({ width = 40, height = 40, color = '#E3E0DF' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width={39} height={39} rx="19.5" fill="white" />
      <path d="M14 20H26" stroke="#32302D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20 26L20 14" stroke="#32302D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="0.5" y="0.5" width={39} height={39} rx="19.5" stroke={color} />
    </svg>
  )
}
